import { Component } from '@angular/core';


@Component({
  selector: 'profile',
  template: require('./profile.component.html'),
  styles: [require('./profile.component.scss')],
})
export class ProfileComponent {
  constructor() {
  }

  doNothing(): void {
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/profile/profile.component.ts